import type { ProductDef } from '@/config/products'
import type { SearchItem } from '@/config/searchData'

const icon = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
  </svg>
)

const same = <T,>(s: T) => ({ en: s, zh: s, zh_CN: s, jp: s, ko: s })

/**
 * Search entries for the products the site shows. Names are brand names and
 * descriptions are the owner's text, so they read the same in every language;
 * the header resolves the address from the product when one is chosen.
 */
export function productSearchItems(products: ProductDef[], language: string): SearchItem[] {
  return products.map((p) => ({
    id: p.id,
    title: same(p.name),
    description: same(p.description),
    keywords: same(p.name.toLowerCase().split(/\s+/).filter(Boolean)),
    category: 'product',
    icon,
    href: p.href(language),
    external: p.external
  }))
}
